<template>
  <div class="mc-widget-call__call-item-container">
    <div class="mc-widget-call__vehicle-information">
      <h5 class="mc-widget-call__licenseplate">{{ licensePlate }}</h5>
      <p class="mc-widget-call__driver" :title="driver ?? $t('global.text.noDriver')">
        {{ driver ?? $t('global.text.noDriver') }}
      </p>
    </div>
    <div class="mc-widget-call__connecting">
      <p>{{ $t('trackVideo.connecting') + '...' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConnectingState',
  props: {
    licensePlate: {
      type: String,
      required: true,
    },
    driver: {
      type: String,
      required: false,
    },
  },
}
</script>
